import { Sparkles } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { usePostHog } from 'posthog-js/react';

interface QuickActionBarProps {
  content: string;
  onContentUpdate: (newContent: string) => void;
}

export const QuickActionBar = ({ content, onContentUpdate }: QuickActionBarProps) => {
  const posthog = usePostHog();
  const showAiWritingOptions = posthog?.isFeatureEnabled('show-ai-writing-options');

  const handleWritingOperation = async (operation: string) => {
    if (!content.trim()) {
      toast.error("Please add some content first");
      return;
    }

    const toastId = toast.loading("Updating content...");

    try {
      const { data, error } = await supabase.functions.invoke('ai-writing-function', {
        body: { 
          content: content,
          operation: operation
        },
      });

      if (error) throw error;

      onContentUpdate(data.generatedText);
      toast.dismiss(toastId);
      toast.success("Content updated successfully!");
    } catch (error) {
      console.error('Error updating content:', error);
      toast.dismiss(toastId);
      toast.error("Failed to update content");
    }
  };

  if (!showAiWritingOptions) return null;

  return (
    <div className="flex items-center justify-center gap-2">
      <button
        className="flex items-center gap-1 text-xs px-2 py-1 rounded hover:bg-primary/5 text-muted-foreground hover:text-primary transition-colors"
        onClick={() => handleWritingOperation('shorter')}
      >
        <Sparkles className="h-3 w-3" />
        <span>Shorter</span>
      </button>
      <button
        className="flex items-center gap-1 text-xs px-2 py-1 rounded hover:bg-primary/5 text-muted-foreground hover:text-primary transition-colors"
        onClick={() => handleWritingOperation('longer')}
      >
        <Sparkles className="h-3 w-3" />
        <span>Longer</span>
      </button>
      <button
        className="flex items-center gap-1 text-xs px-2 py-1 rounded hover:bg-primary/5 text-muted-foreground hover:text-primary transition-colors"
        onClick={() => handleWritingOperation('professional')}
      >
        <Sparkles className="h-3 w-3" />
        <span>Professional</span>
      </button>
      <button
        className="flex items-center gap-1 text-xs px-2 py-1 rounded hover:bg-primary/5 text-muted-foreground hover:text-primary transition-colors"
        onClick={() => handleWritingOperation('viral')}
      >
        <Sparkles className="h-3 w-3" />
        <span>Viral</span>
      </button>
    </div>
  );
}; 